import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Router } from '@angular/router';
import { fuseAnimations } from '../../../../../../core/animations';
import { AuthenticationService } from '../../../../../services/authentication/authentication.service';
import { DivisionService } from '../../../../../services/divisions/division.service';
import { ShiftService } from '../../../../../services/shifts/shift.service';
import { SweetAlertService } from '../../../../../services/sweet-alert/sweet-alert.service';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
    selector: 'fuse-add-edit-divisionr',
    templateUrl: 'add-edit-course-year.component.html',
    styleUrls: ['./add-edit-course-year.component.scss'],
    animations: fuseAnimations
})
export class AddEditCourseYearComponent implements OnInit, OnDestroy {
    @BlockUI('tracker') blockUIList: NgBlockUI;
    public contador = 0;
    courseYearFormGroup;
    courseYearNameFormControl;

    ngOnDestroy(): void {
    }

    ngOnInit(): void {
        console.log('data>>>>>>>>>', this.data);
        this.contador = 0;
    }

    constructor(private authenticationService: AuthenticationService,
                @Inject(MAT_DIALOG_DATA) public data: any,
                public dialogRef: MatDialogRef<AddEditCourseYearComponent>,
                public dialog: MatDialog,
                public divisionService: DivisionService,
                public shiftService: ShiftService,
                private router: Router,
                private fb: FormBuilder,
                private sweetAlertService: SweetAlertService) {
        this.initializeFormControlValidators();
    }

    initializeFormControlValidators() {
        this.courseYearFormGroup = this.fb.group({
            courseYearNameFormControl: ['', [Validators.required]],
        });
    }

    checkValidationErrors() {
        setTimeout(() => {
        }, 20);
    }

    save() {
        if (this.data.mode === 'new') {
            this.dialogRef.close(this.data.courseYear);
        } else {
            this.dialogRef.close(this.data.courseYear);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/curricula/add-edit-course-year/add-edit-course-year.component.ts